import { evaluate } from "mathjs";

/**
 * Safely evaluates a user-supplied arithmetic expression.
 *
 * Handles German decimal notation (comma → period) and common multiplication
 * symbols (×, x, ÷). Returns a number rounded to 3 decimal places, or null
 * if the expression is empty, invalid, or produces a non-finite result.
 *
 * @param {string} expression - Raw user input (e.g. "2,5 × 3 + 1")
 * @returns {number|null}
 */
export function evaluateExpression(expression) {
    try {
        if (!expression || String(expression).trim() === "") return null;

        const normalised = String(expression)
            .replace(/[xX×]/g, "*")
            .replace(/÷/g, "/")
            // German decimal comma: only replace comma between digits
            .replace(/(\d),(\d)/g, "$1.$2");

        const result = evaluate(normalised);

        if (typeof result !== "number" || !isFinite(result) || isNaN(result)) {
            return null;
        }

        return Math.round((result + Number.EPSILON) * 1000) / 1000;
    } catch {
        return null;
    }
}
